/** 实名认证场景枚举 */
export enum AuthSceneTypeEnum {
    /** 授信流程 */
    PRE_LENDING = 1,
    /** 资料修改流程 */
    EDIT =2
}

/** 平台非身份证实名认证用户tips定义，根据场景 */
export const dialogTipsMap = new Map([
  [AuthSceneTypeEnum.PRE_LENDING, {
    title: '抱歉，无法申请额度',
    content: '抱歉，您在哈啰已做过非身份证类型的实名认证，臻有钱暂时无法识别，如需要申请额度，请更换手机号重试。',
    confirmText: '知道了',
  }],
  [AuthSceneTypeEnum.EDIT, {
    title: '抱歉，无法认证',
    content: '抱歉，您已在哈啰做过非身份证的实名认证，无法再次认证',
    confirmText: '知道了',
  }],
]);

/** 弹窗埋点id定义 */
export const dialogUbtName = new Map([
  [AuthSceneTypeEnum.PRE_LENDING, {
    otherType: 'finance_identityInformation_otherType',
    needUpdatePhoto: 'finance_identityInformation_noPhoto',
  }],
  [AuthSceneTypeEnum.EDIT, {
    otherType: 'finance_myProfile_otherType',
    needUpdatePhoto: 'finance_identityInformation_noPhoto',
  }],
]);
